import { FeatureFlags } from '../../FeatureFlags';
import { Order } from '../../helpers/Order';
import { IOrderClause } from '../../ServerApi/types/IOrderClause';
import { OrderKeys } from '../OrderKeys';
import { SortOptions } from './CommonSortOptions';
import { OptionsDictionary } from './SortOptionDefinitions';

export const getFavoritesSpaceDefaultSortOrder = (): IOrderClause[] => {
  return FeatureFlags.reorderFavoritesEnabled
  ? [Order.asc(OrderKeys.position)]
  : [Order.desc(OrderKeys.position)];
};

export const favoritesMixedContentOptions_reorderFavoritesOn: OptionsDictionary = {
  // Mixed Content does not support relevance
  'name': SortOptions.name,
  'type': SortOptions.type,
  'owner': SortOptions.mixedContentOwner,
  'updated': SortOptions.updated,
  'dateAdded': SortOptions.dateAdded,
  'position': SortOptions.position
};

// remove with FeatureFlags.reorderFavoritesEnabled
export const favoritesMixedContentOptions_reorderFavoritesOff: OptionsDictionary = {
  // Mixed Content does not support relevance
  'name': SortOptions.name,
  'type': SortOptions.type,
  'owner': SortOptions.mixedContentOwner,
  'updated': SortOptions.updated,
  'position': SortOptions.position_reorderFavoritesOff,
};

export const getFavoritesMixedContentOptions = (): OptionsDictionary => {
  return FeatureFlags.reorderFavoritesEnabled ? favoritesMixedContentOptions_reorderFavoritesOn : favoritesMixedContentOptions_reorderFavoritesOff;
};
